import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

type InitialState = {
	activeSpotlightIndex: number | null;
	lastActiveSpotlightIndex: number | null;
};

const initialState: InitialState = {
	activeSpotlightIndex: null,
	lastActiveSpotlightIndex: null,
};

const Store = createStore({
	initialState,
	actions: {
		goToStep:
			(nextStep: number): (({ setState }: StoreActionApi<InitialState>) => void) =>
			({ setState }) => {
				setState({ activeSpotlightIndex: nextStep });
			},
		resetTour:
			(): (({ setState }: StoreActionApi<InitialState>) => void) =>
			({ setState }) => {
				setState(initialState);
			},
		initiateTour:
			(): (({ setState }: StoreActionApi<InitialState>) => void) =>
			({ setState }) => {
				setState({
					activeSpotlightIndex: 0,
				});
			},
		proceedToNext:
			(): (({ setState, getState }: StoreActionApi<InitialState>) => void) =>
			({ setState, getState }) => {
				const { activeSpotlightIndex } = getState();
				if (activeSpotlightIndex === null) return;

				setState({
					activeSpotlightIndex: activeSpotlightIndex + 1,
					lastActiveSpotlightIndex: activeSpotlightIndex,
				});
			},
		concludeTour:
			(): (({ setState, getState }: StoreActionApi<InitialState>) => void) =>
			({ setState, getState }) => {
				const { activeSpotlightIndex } = getState();

				setState({
					activeSpotlightIndex: null,
					lastActiveSpotlightIndex: activeSpotlightIndex,
				});
			},
	},
});

export const useMoreActionsObjectSidebarTourState: HookFunction<
	InitialState,
	BoundActions<
		InitialState,
		{
			goToStep: (nextStep: number) => ({ setState }: StoreActionApi<InitialState>) => void;
			resetTour: () => ({ setState }: StoreActionApi<InitialState>) => void;
			initiateTour: () => ({ setState }: StoreActionApi<InitialState>) => void;
			proceedToNext: () => ({ setState, getState }: StoreActionApi<InitialState>) => void;
			concludeTour: () => ({ setState, getState }: StoreActionApi<InitialState>) => void;
		}
	>,
	void
> = createHook(Store);
export const useMoreActionsObjectSidebarTourActions: HookActionsFunction<
	BoundActions<
		InitialState,
		{
			goToStep: (nextStep: number) => ({ setState }: StoreActionApi<InitialState>) => void;
			resetTour: () => ({ setState }: StoreActionApi<InitialState>) => void;
			initiateTour: () => ({ setState }: StoreActionApi<InitialState>) => void;
			proceedToNext: () => ({ setState, getState }: StoreActionApi<InitialState>) => void;
			concludeTour: () => ({ setState, getState }: StoreActionApi<InitialState>) => void;
		}
	>
> = createActionsHook(Store);
